import React from 'react';
import {Table} from '../../../components/table/Table';
import {useInvoke} from '../../../controllers/useInvoke';

const TITLE = {
  field: 'case_study_title',
  header: 'Title',
  responsive: 'sm',
};

const URL = {
  field: 'case_study_url',
  header: 'URL',
};

const CREATEDON = {
  type: 'date',
  field: 'created_on',
  header: 'Created On',
};

const COMPLETEDON = {
  type: 'date',
  field: 'completed_date',
  header: 'Completed On',
};

const ATTACHMENTS = {
  type: 'file',
  field: 'attachments',
  header: 'Work',
};

export const CaseStudyActiveTable = props => {
  const {
    route: {params},
    navigation,
    searchValue,
  } = props;
  const {communicationFilter, themeFilter} = params;
  const invoke = useInvoke({
    method: 'put',
    eventSourceId: ['caseStudyAdded'],
  });
  const markComplete = ({row}) => {
    invoke({
      uri: `/casestudies/${row?._id}`,
      props: {
        status: 'completed',
        completed_date: new Date(),
      },
    });
  };
  return (
    <Table
      search={searchValue}
      searchFields={'case_study_title'}
      api={`/caseStudies`}
      eventSourceId={['caseStudyAdded']}
      addOnFilter={{
        status: 'active',
        ...communicationFilter,
        ...themeFilter,
      }}
      params={params}
      onRowPress={row => {
        navigation.navigate('edit-case-study', row);
      }}
      columns={[
        TITLE,
        URL,
        ATTACHMENTS,
      ]}
      moreActions={[
        {
          title: 'Mark Completed',
          onPress: markComplete,
        },
      ]}
    />
  );
};

export const CaseStudyCompletedTable = ({route: {params}, searchValue}) => {
  const {communicationFilter, themeFilter} = params;
  return (
    <Table
      search={searchValue}
      searchFields={'case_study_title'}
      api={`/case-study`}
      eventSourceId={['caseStudyAdded']}
      addOnFilter={{
        status: 'completed',
        ...communicationFilter,
        ...themeFilter,
      }}
      params={params}
      columns={[TITLE, URL, ATTACHMENTS, COMPLETEDON]}
    />
  );
};
